import * as React from 'react';

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import { Transition } from './Transition';

const BootstrapDialog = styled(Dialog)<{
  customWidth?: string;
  customMaxWidth?: string;
}>(({ theme, customWidth, customMaxWidth }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(2),
    gap: theme.spacing(0.5),
  },
  '& .MuiDialog-paper': {
    borderRadius: theme.spacing(0.5),
    ...(customWidth && { width: customWidth }),
    ...(customMaxWidth && { maxWidth: customMaxWidth }),
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  canCloseWithBgClick?: boolean;
  width?: string;
  maxWidth?: string;
}

export const DialogContainer = ({
  open,
  onClose,
  children,
  canCloseWithBgClick = true,
  width,
  maxWidth,
}: Props) => {
  const handleClose = (_: object, reason: string) => {
    if (!canCloseWithBgClick && reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <BootstrapDialog
      //@ts-ignore: Need to disable tabIndex for 'Create new matter' modal to work
      TransitionProps={{ tabIndex: '' }}
      sx={{
        zIndex: 1,
      }}
      onClose={handleClose}
      open={open}
      TransitionComponent={Transition}
      customWidth={width}
      customMaxWidth={maxWidth}
    >
      {children}
    </BootstrapDialog>
  );
};
